export default __webpack_public_path__ + "static/media/warning--wild-animals--g3.ed95b4b7.png";